import React, { useState, useRef } from "react";
import { Button, MenuItem, Box } from "@mui/material";
import { CiCircleList } from "react-icons/ci";
import { FiCheckCircle } from "react-icons/fi";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdOutlinePendingActions } from "react-icons/md";

const FilterButton = ({ selectedFilter, onFilterChange, labels, t, direction }) => {
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const buttonRef = useRef(null);
    let timer;
    // Handle showing submenu (on mouse enter)
    const handleMouseEnter = (event) => {
        clearTimeout(timer);
        setAnchorEl(event.currentTarget);
        setSubmenuOpen(true);
    };

    // Handle hiding submenu (with a delay)
    const handleMouseLeave = () => {
        timer = setTimeout(() => {
            setSubmenuOpen(false);
            setAnchorEl(null);
        }, 200);
    };

    // Icons for each filter type
    const getFilterIcon = (filter) => {
        switch (filter) {
            case "Accepted":
                return <FiCheckCircle style={{ marginRight: "10px", color: "#209F84", fontSize: "20px", ml: "10px" }} />;
            case "Rejected":
                return <IoCloseCircleOutline style={{ marginRight: "10px", color: "#F44336", fontSize: "20px", ml: "10px" }} />;
            case "Pending":
                return <MdOutlinePendingActions style={{ marginRight: "10px", color: "#FFC107", fontSize: "20px", ml: "10px" }} />;
            case "All":
                return <CiCircleList style={{ marginRight: "10px", color: "#676464", fontSize: "20px", ml: "10px" }} />;
            default:
                return null;
        }
    };

    // Helper to get the full name of the filter
    const getFilterName = (filter) => {
        switch (filter) {
            case "Accepted":
                return labels.acceptedLabel || "Accepted ";
            case "Rejected":
                return labels.rejectedLabel || "Rejected ";
            case "Pending":
                return labels.pendingLabel || "Pending ";
            case "All":
                return labels.allLabel || "All ";
            default:
                return labels.allLabel || "All ";
        }
    };
    const hasAccepted = labels.rejectedLabel;
    return (
        <Box>
            <Button
                ref={buttonRef}
                variant="outlined"
                onMouseEnter={handleMouseEnter} // Show on hover
                onMouseLeave={handleMouseLeave}
                sx={{
                    color: "var(--text-color)",
                    borderColor: "var(--primary-color)",
                    backgroundColor: "var(--secondary-color)",
                    textTransform: "none",
                    border: "1px solid var(--primary-color)",
                    fontSize: { md: "16px", xs: "13px" },
                    fontWeight: 600,
                    padding: { md: "10px 20px", xs: "12px" },
                    borderRadius: "12px",
                    minWidth: "auto",
                    textAlign: direction === "rtl" ? "right" : "left",
                    justifyContent: direction === "rtl" ? "start" : "end",
                    "&:hover": {
                        backgroundColor: "var(--primary-color-light)",
                        borderColor: "var(--primary-color-dark)",
                        color: "#fff"
                    },
                    flexDirection: direction === "rtl" ? "row-reverse" : "row",
                }}
            >
                {getFilterName(selectedFilter)} {getFilterIcon(selectedFilter)}
            </Button>

            {/* Dropdown Box */}
            {submenuOpen && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "32%",
                        left: direction === "rtl" ? "0" : "auto", // Align to the left for LTR
                        right: direction === "ltr" ? "40px" : "auto",
                        width: "200px",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                        zIndex: 1300, // Ensure it's on top
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >

                    <MenuItem
                        onClick={() => onFilterChange("Accepted")}
                        sx={{
                            justifyContent: direction === "ltr" ? "flex-end" : "flex-start",
                            fontSize: { md: "16px", xs: "13px" },
                        }}
                    >
                        {labels.acceptedLabel || "Accepted "}{" "}
                        <FiCheckCircle style={{ marginRight: "10px", color: "#209F84", ml: "10px" }} />
                    </MenuItem>

                    {hasAccepted && (
                        <MenuItem onClick={() => onFilterChange("Rejected")} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start", fontSize: { md: "16px", xs: "13px" } }}>
                            {labels.rejectedLabel || "Rejected "} <IoCloseCircleOutline style={{ marginRight: "10px", color: "#F44336", ml: "10px" }} />
                        </MenuItem>)}
                    <MenuItem onClick={() => onFilterChange("Pending")} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start", fontSize: { md: "16px", xs: "13px" } }}>
                        {labels.pendingLabel || "Pending "} <MdOutlinePendingActions style={{ marginRight: "10px", color: "#FFC107", ml: "10px" }} />
                    </MenuItem>
                    <MenuItem onClick={() => onFilterChange("All")} sx={{ justifyContent: direction === "ltr" ? "flex-end" : "flex-start", fontSize: { md: "16px", xs: "13px" } }}>
                        {labels.allLabel || "All "} <CiCircleList style={{ marginRight: "10px", color: "#676464", ml: "10px" }} />
                    </MenuItem>
                </Box>
            )}
        </Box>
    );
};

export default FilterButton;
